import templateUrl from "./send-sms.html";
import "./send-sms.scss";

export const sendMessageComponent = {
  bindings: {
    membersData: "<",
  },
  templateUrl,

  controller: class SendMessageComponent {
    constructor($state, toastr, UserService, Constants, SendMessageService) {
      "ngInject";

      this.$state = $state;
      this.toastr = toastr;
      this.Constants = Constants;
      this.UserService = UserService;
      this.SendMessageService = SendMessageService;
    }
    $onInit() {
      this.membersList = [];
      this.messageText = "";
      this.memberSearchKeyword = "";
      this.selectMembersError = false;
      this.currentMembersPage = 1;
      this.itemPerMemberPage = 10;
      this.showMembersViewMore = false;
      this.disabledMembersAutoComplete = false;
      this.selectMembersTitle = "Select Members";
      this.showMembersViewMore =
        this.membersData &&
        this.membersData.userList.length >= this.itemPerMemberPage;

      if (this.membersData && this.membersData.userList.length > 0) {
        this.membersList = [
          ...this.membersList,
          ...this._formatMembersList(this.membersData.userList),
        ];
      }
    }

    onSearchMembers(value) {
      this.memberSearchKeyword = value;
      return this._getUserList({ searchKeyword: value });
    }

    _formatMembersList(list, showAllOption = true) {
      if (showAllOption) {
        list.unshift({
          id: Math.random(),
          name: "All",
          isSelected: false,
          value: "All",
          sendKey: "All",
        });
      }
      return list.map((value) => {
        return {
          id: value.accountId,
          name: value.name,
          subName: value.phoneNumber
            ? `${value.phoneDialCode} ${value.phoneNumber}`
            : "",
          isSelected: false,
          value: value.name,
          sendKey: value.name,
        };
      });
    }

    onChangeMember(details) {
      this.selectMembersError = false;
      this.membersList = this.membersList.map((member) => {
        if (details.parent.name === "All") {
          // if 'All' option is selected, then make all
          // other option as unselected
          if (member.name !== "All") {
            member.isSelected = false;
          }
        } else {
          // make 'All' option as unselected
          if (member.name === "All") {
            member.isSelected = false;
          }
        }
        return member;
      });
    }

    loadMoreMembers() {
      this.currentMembersPage = this.currentMembersPage + 1;
      let params = {
        sortBy: "name_asc",
        pageId: this.currentMembersPage,
        limit: this.itemPerMemberPage,
        memberWithContactNumber: true,
      };
      if (this.memberSearchKeyword) {
        params.searchKeyword = this.memberSearchKeyword;
      }
      return this._getUserList(params, true);
    }

    _getUserList(params, loadMore) {
      params.sortBy = "name_asc";
      this.UserService.getUserList(params)
        .then((details) => {
          this.showMembersViewMore =
            details.totalCount > this.itemPerMemberPage &&
            details.userList.length >= this.itemPerMemberPage;
          if (loadMore) {
            this.membersList = [
              ...this.membersList.filter(
                (value) =>
                  !params.searchKeyword ||
                  (params.searchKeyword && value.name !== "All")
              ),
              ...this._formatMembersList(details.userList, false),
            ];
          } else {
            this.membersList = [
              ...this._formatMembersList(
                details.userList,
                params.searchKeyword ? false : true
              ),
            ];
          }
        })
        .catch((errmsg) => {
          if (errmsg.xhrStatus !== "abort") {
            this.toastr.error(errmsg);
          }
        });
    }

    onSubmit() {
      const selectedMembers = this.membersList.filter(
        (member) => member.isSelected
      );
      const sendToAll =
        selectedMembers.length > 0 && selectedMembers[0].value === "All";
      this.selectMembersError = false;
      this.selectMembersError = false;
      if (!sendToAll && selectedMembers.length === 0) {
        this.selectMembersError = true;
      } else {
        this.SendMessageService.sendMessageToVeterans({
          sendToAll,
          message: this.messageText,
          veteransIds: sendToAll
            ? []
            : selectedMembers.map((member) => member.id),
        })
          .then((_) => {
            this.toastr.success("Message sent successfully.");
            this.$state.go("home");
          })
          .catch(({ data }) => {
            this.toastr.error(data.errors.message);
          });
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/send-sms/send-sms.component.js